import { render, staticRenderFns } from "./orderCell.vue?vue&type=template&id=2efdb0f4&scoped=true"
import script from "./orderCell.vue?vue&type=script&lang=js"
export * from "./orderCell.vue?vue&type=script&lang=js"
import style0 from "./orderCell.vue?vue&type=style&index=0&id=2efdb0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efdb0f4",
  null
  
)

export default component.exports